import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';
import STUDENT_LICENSE_USAGE_FRAGMENT from 'graph/fragments/student-license-usage';
import GROUPS_FRAGMENT from 'graph/fragments/groups';

const GET_STUDENT = gql`
  query getStudentQuery($where: StudentWhereInput!) {
    student(where: $where) {
      ...BaseStudent
      licenseUsage {
        ...BaseStudentLicenseUsage
      }
      groups {
        ...BaseGroups
      }
    }
  }
  ${STUDENT_FRAGMENT}
  ${STUDENT_LICENSE_USAGE_FRAGMENT}
  ${GROUPS_FRAGMENT}
`;

export default GET_STUDENT;
